import { API } from '@/api/Api'
import { FindBankRegressionData } from '@/api/query/Rates.graphql'

export default {
  // Queries
  async FindBankRegressionData (accountId) {
    const Data = { accountId: accountId }
    return await API.GQLRequest(FindBankRegressionData, Data)
  }
}
